import { useState } from 'react';

import type { ShelfEntry } from '@/types/feed';

import { PastShelfCard } from './PastShelfCard';

interface ShelfHistorySectionProps {
  history: ShelfEntry[];
  // Passed through to each card so a successful re-add re-syncs the lists.
  refetch: () => Promise<void>;
}

export function ShelfHistorySection({ history, refetch }: ShelfHistorySectionProps) {
  // Collapsed by default — history is discoverable but stays out of the way.
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-t border-wolisho-brown/10 mt-7 pt-5">
      <button
        type="button"
        data-testid="shelf-history-toggle"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
        className="w-full flex items-center justify-between pb-3"
      >
        <span className="text-base font-bold text-black/50">Previously shelved</span>
        <span className="flex items-center gap-1.5 text-black/35">
          <span className="text-[13px] font-bold">{history.length}</span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="flex flex-col gap-3" data-testid="shelf-history-list">
          {history.map((entry) => (
            <PastShelfCard key={entry.coffee.id} entry={entry} refetch={refetch} />
          ))}
        </div>
      )}
    </div>
  );
}
